export const MKSLocationData = {
  locations: [
    {
      continent: "Americas",
      country: "Argentina",
      businessName: "Atotech Argentina S.A.",
      abbreviation: "BAAT",
      address: "Paraná 4574, (1605) Buenos Aires, Argentina",
      position: { lat: -34.5046, lng: -58.4924 },
      size: "NA",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Plano",
      abbreviation: "PLAN",
      address: "801 Legacy Drive, Plano, TX, 75023",
      position: { lat: 33.0198, lng: -96.6989 },
      size: "DC",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Tokyo",
      abbreviation: "TOK 1",
      address: "2-7-3 Marunouchi, Chiyoda-ku, Tokyo, 100-6432",
      position: { lat: 35.6762, lng: 139.6503 },
      size: "DC",
    },
    {
      continent: "Americas",
      country: "Brazil",
      businessName: "Galvanotécnica Ltda. - Atotech",
      abbreviation: "TABO",
      address:
        "Rua Maria Patricia da Silva, 205, Taboão da Serra-SP, CEP 06787-480, Brasil",
      position: { lat: -23.6227, lng: -46.7619 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "Canada",
      businessName: "Atotech Canada Ltd.",
      abbreviation: "BURL",
      address: "1180 Corporate Drive, Burlington, Ontario L7L 5R6, Canada",
      position: { lat: 43.3593, lng: -79.7895 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "Canada",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "VAN",
      address: "130-13500 Verdun Place, Richmond, BC V6V 1V2, Canada",
      position: { lat: 49.1666, lng: -123.0724 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "Mexico",
      businessName: "Atotech de México S.A. de C.V.",
      abbreviation: "QUAT 1",
      address:
        "Carretera Estatal 100, No. 4200 Lote 33/34, Interior 4-H/4-G Parque Industrial Aeropuerto San Ildefonso, Colon, Querétaro, México, C.P, 76295.",
      position: { lat: 20.6851, lng: -100.1858 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "Mexico",
      businessName: "Atotech de México S.A. de C.V.",
      abbreviation: "QUAT 2",
      address:
        "IZA BC Torre 578 Piso 14, Prol. Blvd Bernardo Quintana 300, Col. Centro Sur, Santiago de Querétaro, Qro. CP 76090",
      position: { lat: 20.5881, lng: -100.3883 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "Mexico",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "NOG",
      address: "Parque Industrial Nuevo Nogales, Nogales, Sonora 84094",
      position: { lat: 31.2854, lng: -110.9559 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "ROC-H",
      address: "100 Highpower Road, Rochester, NY 14623",
      position: { lat: 43.0845, lng: -77.6399 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "BRM",
      address: "11380 Reed Way, Broomfield, CO 80020",
      position: { lat: 39.9205, lng: -105.0867 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "Rinchem - Atotech",
      abbreviation: "SF",
      address: "11903 Pike Street, Santa Fe Springs, CA 90670",
      position: { lat: 33.9317, lng: -118.0705 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "AUS",
      address: "1321 Rutherford Lane, Austin, TX.",
      position: { lat: 30.3359, lng: -97.7058 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "BVT",
      address: "14523 SW Millikan Wy, Beaverton, OR. 97005",
      position: { lat: 45.4989, lng: -122.8233 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "BOZ",
      address: "151 Evergreen Ste D., Bozeman, MT",
      position: { lat: 45.677, lng: -111.0429 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "MIL",
      address: "1565 Barber Lane, Milpitas, CA. 95035",
      position: { lat: 37.4154, lng: -121.9008 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "LAW",
      address: "17 Ballard Way, Lawrence, MA. 01843",
      position: { lat: 42.701, lng: -71.1631 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "Atotech USA, LLC",
      abbreviation: "ROCK",
      address: "1750 Overview Drive, Rock Hill, SC 29730",
      position: { lat: 34.9513, lng: -81.032 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "IRV",
      address: "1791 Deere Ave., Irvine, CA. 92606",
      position: { lat: 33.7008, lng: -117.8516 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "2TDR",
      address: "2 Tech Drive, Andover, MA. 01810",
      position: { lat: 42.6583, lng: -71.1446 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "Bushnell - Atotech",
      abbreviation: "PORT",
      address: "2720 NW 35th Avenue, Portland, OR 97210",
      position: { lat: 45.5405, lng: -122.7144 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "LOG",
      address: "3050 North 300 West, North Logan, UT.",
      position: { lat: 41.7694, lng: -111.8047 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "Atotech USA, LLC",
      abbreviation: "DETR",
      address: "35840 Beattie Drive, Sterling Heights, MI 48312",
      position: { lat: 42.5844, lng: -83.0477 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "KFL",
      address: "4700 ESI Way, Klamath Falls, OR. 97601",
      position: { lat: 42.1969, lng: -121.7327 },
      size: "Medium",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "HAV",
      address: "55 Foundation Ave., Haverhill, MA. 01831",
      position: { lat: 42.7762, lng: -71.0873 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "AND",
      address: "6 Shattuck Road, Andover, MA. 01810",
      position: { lat: 42.6598, lng: -71.1375 },
      size: "DC",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "MET",
      address: "651 Lowell Street, Methuen, MA. 01844",
      position: { lat: 42.7373, lng: -71.1906 },
      size: "Large",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "ROC-STP",
      address: "705 St. Paul Street, Rochester, NY 14623",
      position: { lat: 43.1516, lng: -77.6109 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "FRA",
      address: "8 East Forge Parkway, Franklin, MA",
      position: { lat: 42.0834, lng: -71.4167 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "ROC-LIN",
      address: "820 Linden Ave, Rochester, NY 14623",
      position: { lat: 43.1297, lng: -77.5825 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "Royal Chemical",
      abbreviation: "MACE",
      address: "8679 South Freeway Drive, Macedonia, OH 44056",
      position: { lat: 41.3119, lng: -81.5036 },
      size: "Small",
    },
    {
      continent: "Americas",
      country: "United States",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "WIL",
      address: "90 Industrial Way, Wilmington, MA. 01887",
      position: { lat: 42.5465, lng: -71.1773 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "SHA",
      address: "#1000 Jinhai Road, Pudong New District, Shanghai, 201209",
      position: { lat: 31.2304, lng: 121.5437 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "NNJG & WUHA",
      address:
        "4/F., Donglai Business Center, No. 30, Longpan ZhongLu, Nanjing, China 210016",
      position: { lat: 32.0584, lng: 118.7965 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "GUNG",
      address:
        "73, Xinzhuang 2-Lu, Yonghe District, GETDD, Guangzhou, China 511356",
      position: { lat: 23.1291, lng: 113.2644 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "HUIZ",
      address:
        "Block B,5/F,Donghui Chengjian Building, No.49 Dongping Dadao, Huizhou, China 516002",
      position: { lat: 23.1118, lng: 114.4161 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "CHNG",
      address:
        "Building 2, Zhongrun Industrial Park, No. 252, Tonghe Road, Tongliang Dist., Chongqing, China 400039",
      position: { lat: 29.5647, lng: 106.5116 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "DONG",
      address:
        "Dongguan Laboratory, Rm. 1209-1210, Block B, Chuangfeng Commercial Building, Humen Main Road, Humen Town, Dongguan, China 523900",
      position: { lat: 22.8226, lng: 113.6727 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "QING",
      address:
        "Floor 3,Building 2, No. 299, Chongqing Middle Road, Licang District, 266121 Qingdao, China",
      position: { lat: 36.0671, lng: 120.3826 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "SHE",
      address: "HongXiang Industrial Park, Shenzhen, 518102",
      position: { lat: 22.5431, lng: 114.0579 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "ZHON",
      address:
        "Honyu Building 6/F, No.144 Middle Xiaolan Road, Zhongshan City, Guangdong, China 528416",
      position: { lat: 22.5197, lng: 113.3462 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "WUX",
      address: "Lot J3-8, Wuxi Export Processing Zone, Wuxi, Jiangsu 214028",
      position: { lat: 31.4912, lng: 120.3119 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "TIAN",
      address:
        "No. 2, Dong FangHong Road, Economic Development Zone of JingHai, Tianjin, China 301600",
      position: { lat: 39.0042, lng: 117.3887 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "SNGA",
      address:
        "No. 5399 Plant A6, Wai Qing Song Road, Qingpu District, Shanghai, China 201707",
      position: { lat: 31.1989, lng: 121.1233 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "WENZ",
      address:
        "No. 7, Juxin Road, Juguang, Industrial Park, Wenzhou City, China 325027",
      position: { lat: 28.0151, lng: 120.6668 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "YANG",
      address:
        "No.11, Hua Dian Road, Yangzhou Chemical Industry Park, Yizheng, Yangzhou, Jiangsu, China 211400",
      position: { lat: 32.2731, lng: 119.1854 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "ZHAO",
      address:
        "North Wing, 12/F, No. 18, Beijiang Boulevard, Zhaoqing High-tech Industrial Development Zone, 526238, CHINA",
      position: { lat: 23.0471, lng: 112.465 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "NINB",
      address:
        "Room 802, No.45, Lane 578, South Tiantong Road, Yinzhou District, Ningbo, China 315100",
      position: { lat: 29.8683, lng: 121.544 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "China",
      businessName: "Atotech (China) Chemicals Ltd.",
      abbreviation: "XIAM",
      address:
        "Unit 03, floor 10, Technical service Building, Pilot base, No.120,X inyuan road, Haicang district Xiamen,Fujian, China 361022",
      position: { lat: 24.4798, lng: 118.0819 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Hong Kong",
      businessName: "Atotech Asia Pacific Ltd.",
      abbreviation: "KOWL",
      address:
        "Unit 906-909, 9/F, Mira Place Tower A, 132 Nathan Road, Tsim Sha Tsui, Kowloon, Hong Kong",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "BANG",
      address:
        "111 & 112, Phase - IV Boomasandra Industrial Area, Bangalore 560099, Karnataka, India",
      position: { lat: 13.1986, lng: 77.6968 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "PUNE",
      address:
        "128/2, Sanghavi Complex, Telco Road, Chinchwad, Pune, Maharashtra - 411019, India",
      position: { lat: 18.6298, lng: 73.8297 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "HARY",
      address:
        "66, K.M. Stone, NH 8, Delhi Jaipur Highway, Village Sidhrawali Distt. Gurgaon 123413 Haryana India",
      position: { lat: 28.2202, lng: 76.8426 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "TAMI",
      address:
        "First Floor, 152, (SP) Ambattur Industrial Estate, 1st Main Road, 4th Lane Chennai, 600058 India",
      position: { lat: 13.1143, lng: 80.1597 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "LUDH",
      address:
        "First Floor, Zoom Building Property No. B-XXIII, 2581/1, R.K. Road Industrial area A, Ludhiana Punjab, 141003 India",
      position: { lat: 30.901, lng: 75.8573 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech Development Center Private Limited",
      abbreviation: "MNSR",
      address:
        "Plot No. 446 G & H, Sector 8, Phase IV, IMT Manesar Gurgaon - Haryana",
      position: { lat: 28.3709, lng: 76.9266 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "GRGN",
      address:
        "Plot No. 446 G & H, Sector 8, Phase IV, IMT Manesar Gurgaon-Haryana (India)",
      position: { lat: 28.4595, lng: 77.0266 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "India",
      businessName: "Atotech India Private Limited",
      abbreviation: "MUMB",
      address:
        "UNIT No. 209, Krishna Commercial Center 6, Udyog Nagar, Off S. V. Road, Goregaon West, Mumbai, Maharashtra - 400062, India",
      position: { lat: 19.1662, lng: 72.8525 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Israel",
      businessName: "Mks Israel",
      abbreviation: "CAR",
      address: "34 Hanapach st Carmiel",
      position: { lat: 32.914, lng: 35.2952 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "Israel",
      businessName: "Mks Israel",
      abbreviation: "RHVT",
      address: "2 Oppenhaimer st. Rehovot Israel Building B floor 9 and 10",
      position: { lat: 31.8928, lng: 34.8112 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Israel",
      businessName: "Ophir Photonics",
      abbreviation: "JER",
      address: "Hartum 10 Jerusalem Israel",
      position: { lat: 31.7997, lng: 35.2124 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "Atotech Japan K.K.",
      abbreviation: "AICH",
      address:
        "1-6 Shimo-Ohbasan, Mutsuguri, Koda-cho, Nukata-gun, Aichi 444-0122, Japan",
      position: { lat: 34.9167, lng: 137.1333 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "SAI",
      address: "4-384 Sakuragi,Omiya, Saitama-city, Saitama 330-0854 Japan",
      position: { lat: 35.9064, lng: 139.6249 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "Atotech Japan K.K.",
      abbreviation: "KANA",
      address:
        "German Industry Park, 1-18-2 Hakusan, Midori-ku, Yokohama, Kanagawa 226-0006, Japan",
      position: { lat: 35.5147, lng: 139.5413 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "TOK 1",
      address:
        "Kudan First Place Building, 4--1-28 Kudan-kita, Chiyoda-ku, Tokyo, 102-0073",
      position: { lat: 35.6954, lng: 139.752 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "TOK 2",
      address: "Moriichi Building 2F, 14-3 Takabashi, Koto-ku",
      position: { lat: 35.6954, lng: 139.752 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "OSA",
      address:
        "Nishi-Honmachi Solar Building, 3-1-43 Nishi-Honmachi, Nishi-ku, Osaka",
      position: { lat: 34.6937, lng: 135.5023 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Japan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "AKI",
      address:
        "Tokyo-to, Akishima-shi, Matsubara-cho 2-12-11 2F MKS Japan Tokyo Service Center",
      position: { lat: 39.72, lng: 140.1025 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "Korea",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "PLT 1",
      address: "16, Techno 5-ro, Yuseong-gu",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Korea",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "YON",
      address:
        "2,3,4,5,6,7,10th Fl., Leader's Tower,12,Wongomae-ro, Giheung-gu, Yongin-Si, Gyeonggi-Do, South Korea",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "Korea",
      businessName: "Atotech Korea Ltd.",
      abbreviation: "JAHN",
      address:
        "37, Jangangongdan 1-gil, Jangan-myeon, Hwaseong-si, Gyeonggi-do, ZIP: 18579, Korea",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Korea",
      businessName: "Atotech Korea Ltd.",
      abbreviation: "ATKO",
      address:
        "7F Dongsung building, 21 Gukhoe-Daero 62-Gil, Yeongdeungpo-Gu, Seoul, ZIP: 07236, Korea",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "Korea",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "PLT 2",
      address: "Plasmart, 188, Techno 2-ro, Yuseong-gu",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Malaysia",
      businessName: "Atotech Malaysia Sdn. Bhd.",
      abbreviation: "PNNG",
      address:
        "1182, Lorong Perindustrian Bukit Minyak 22, Taman Perindustrian Bukit Minyak, 14100 Simpang Ampat, Pulau Pinang",
      position: { lat: 5.3302, lng: 100.4959 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Malaysia",
      businessName: "Atotech Malaysia Sdn. Bhd.",
      abbreviation: "KUAL",
      address:
        "Lot 6.03A, Level 6, 1 Tech Park, Tanjung Bandar Utama, Bandar Utama, 47800 Petaling Jaya, Selangor Darul Ehsan",
      position: { lat: 3.1502, lng: 101.5655 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Philippines",
      businessName: "Atotech (Philippines) Chemicals, Inc.",
      abbreviation: "MAKA",
      address:
        "401-402 B2 L7, CTP Alpha Building, Investment Drive, Madrigal Business Park, Alabang, Muntinlupa City",
      position: { lat: 14.4241, lng: 121.0439 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "Singapore",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "SNG",
      address: "1 Kaki Bukit View #04-33/34 Techview, Singapore 415941",
      position: { lat: 1.3349, lng: 103.8917 },
      size: "Large",
    },
    {
      continent: "Asia",
      country: "Singapore",
      businessName: "Atotech (Singapore) Chemicals Pte. Ltd.",
      abbreviation: "SPOR & JAKA",
      address:
        "8 Buroh Street, Unit #03-01, Surface Engineering Hub, Singapore 627563",
      position: { lat: 1.2855, lng: 103.7869 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Taiwan",
      businessName: "Atotech Taiwan Limited",
      abbreviation: "GUAN",
      address:
        "11, Jingjian 2nd Rd., Guanyin Industrial Park, Taoyuan City 32853, Taiwan",
      position: { lat: 23.1066, lng: 113.4591 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Taiwan",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "TAI",
      address: "2F No. 47, Ln 2, Sec. 2, Kuang Fu Road, Hsinchu 300",
      position: { lat: 25.0797, lng: 121.5968 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Taiwan",
      businessName: "Atotech Taiwan Limited",
      abbreviation: "TPEI",
      address: "4F., No. 285, Sec. 3 Nanjing E. Rd., Taipei 10550, Taiwan",
      position: { lat: 24.8079, lng: 121.0236 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Taiwan",
      businessName: "Atotech Taiwan Limited",
      abbreviation: "KAOH",
      address:
        "4F., No. 47, Dazhong 2nd Rd., Zuoying Dist., Kaohsiung City 813022, Taiwan",
      position: { lat: 22.7933, lng: 120.2953 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Taiwan",
      businessName: "Atotech Taiwan Limited",
      abbreviation: "TAOY",
      address: "5F., No. 15, Jingguo Rd., Taoyuan City 33050, Taiwan",
      position: { lat: 24.9936, lng: 121.301 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Thailand",
      businessName: "Atotech (Thailand) Co., Ltd.",
      abbreviation: "BKOK",
      address:
        "11th Floor, 1 TP&T Tower, Soi 19, Vibhavadee Rungsit Road, Chatuchak, Chatuchak, Bangkok 10900, Thailand",
      position: { lat: 13.8268, lng: 100.5618 },
      size: "Medium",
    },
    {
      continent: "Asia",
      country: "Thailand",
      businessName: "Atotech (Thailand) Co., Ltd.",
      abbreviation: "PTHU",
      address:
        "144 Thailand Science Park Phahonyothin Rd, Unit RM 308 –311, 3rd Floor, INC2 building, Khlong Luang, Pathum Thani 10120, Thailand",
      position: { lat: 12.9236, lng: 101.1755 },
      size: "Small",
    },
    {
      continent: "Asia",
      country: "Vietnam",
      businessName: "Atotech Vietnam Co., Ltd.",
      abbreviation: "HCMC MSD",
      address:
        "5F Hai Au Building, 39B Truong Son Street, Ward 4, Tan Binh District, Ho Chi Minh City, Vietnam",
      position: { lat: 10.8167, lng: 106.6667 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "Vietnam",
      businessName: "Atotech Vietnam Co., Ltd.",
      abbreviation: "HANO",
      address:
        "Floor 2, VPI Building, Trung Kinh Street, Yen Hoa Ward, Cau Giay District, Hanoi City, Vietnam",
      position: { lat: 21.0285, lng: 105.8042 },
      size: "NA",
    },
    {
      continent: "Asia",
      country: "Vietnam",
      businessName: "MKS Instruments, Inc.",
      abbreviation: "HCMC MKS",
      address:
        "Room 105, Techno Center Building, Thang Long Industrial Park, Kim Chung Commune, Dong Anh District, Ha Noi, Vietnam",
      position: { lat: 22.2988, lng: 114.1722 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "Austria",
      businessName: "Rankweil",
      abbreviation: "RAN",
      address: "Feldgut 9, A-6830 Rankweil",
      position: { lat: 47.2719, lng: 9.6428 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Austria",
      businessName: "Atotech Österreich GmbH",
      abbreviation: "WANT",
      address: "Linzer Straße 63, 3002 Purkersdorf",
      position: { lat: 48.2058, lng: 16.178 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "Romania",
      businessName: "Ophir Optics SRL",
      abbreviation: "BUC",
      address:
        "Str. Racari nr. 5, corp 51B, et. 1, sector 3, Bucuresti, Romania 031827",
      position: { lat: 44.4268, lng: 26.1025 },
      size: "Large",
    },
    {
      continent: "Europe",
      country: "Bulgaria",
      businessName: "Atotech Bulgaria EOOD",
      abbreviation: "SOF",
      address: "Sofia Nadejda BL. 329 vk. A ap. 8, 1220 Sofia",
      position: { lat: 42.7249, lng: 23.3088 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Czech Republic",
      businessName: "Atotech CZ, a.s.",
      abbreviation: "JABL",
      address: "Belgicka 5119, 46605 Jablonec nad Nisou",
      position: { lat: 50.7228, lng: 15.171 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "France",
      businessName: "Atotech France",
      abbreviation: "OLAV",
      address:
        "29, Avenue de l'Eguillette, ZA du Vert Galant, 95310 Saint Ouen l'Aumône",
      position: { lat: 49.0508, lng: 2.1325 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "France",
      businessName: "Brigueuil",
      abbreviation: "BOU",
      address: "La Boulonnie, 16420 Brigueuil",
      position: { lat: 46.0427, lng: 0.7483 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "France",
      businessName: "Beaune La Rolande",
      abbreviation: "BEA",
      address: "Zone Industrielle, 45340 Beaune La Rolande",
      position: { lat: 48.0697, lng: 2.4308 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Berlin",
      abbreviation: "BER",
      address: "11-13 Wattstrasse D-13355",
      position: { lat: 52.55, lng: 13.3833 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Atotech Deutschland GmbH & Co. KG",
      abbreviation: "WERD",
      address: "Ahornallee 4, 16818 Werder",
      position: { lat: 52.3733, lng: 12.935 },
      size: "Large",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Atotech Deutschland GmbH & Co. KG",
      abbreviation: "BRLN",
      address: "Erasmusstr. 20, 10553 Berlin",
      position: { lat: 52.5244, lng: 13.3248 },
      size: "DC",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Darmstadt",
      abbreviation: "DAR",
      address: "Guerickeweg 7, Darmstadt, D-64291",
      position: { lat: 49.8728, lng: 8.6512 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Atotech Deutschland GmbH & Co. KG",
      abbreviation: "FEUC",
      address: "Industriestrasse 69, 90537 Feucht",
      position: { lat: 49.3767, lng: 11.2135 },
      size: "Large",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Stahnsdorf",
      abbreviation: "STA",
      address: "Ruhlsdorfer Strasse 95, Stahnsdorf",
      position: { lat: 52.3919, lng: 13.2014 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Munich",
      abbreviation: "MUN",
      address: "Schatzbogen 43",
      position: { lat: 48.1351, lng: 11.582 },
      size: "Large",
    },
    {
      continent: "Europe",
      country: "Germany",
      businessName: "Atotech Deutschland GmbH & Co. KG",
      abbreviation: "TREB",
      address: "Untergasse 47, Trebur-Geinsheim",
      position: { lat: 49.9141, lng: 8.377 },
      size: "Large",
    },
    {
      continent: "Europe",
      country: "Hungary",
      businessName: "Atotech Österreich GmbH",
      abbreviation: "BDAP",
      address: "Magyarországi Fióktelepe, H-1143 Budapest, Francia út 43.",
      position: { lat: 47.5162, lng: 19.094 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Italy",
      businessName: "Atotech Italia S.r.l.",
      abbreviation: "LAIN",
      address: "Via Lecco, 6, 20045 Lainate (MI)",
      position: { lat: 45.579, lng: 9.0341 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "Italy",
      businessName: "Reggio Emilia",
      abbreviation: "ITA",
      address: "Via P. e M Curie, 8",
      position: { lat: 44.6989, lng: 10.6312 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Lithuania",
      businessName: "UAB Atotech-Chemeta",
      abbreviation: "VILN",
      address: "Konstitucijos pr. 7, LT-09308 Vilnius",
      position: { lat: 54.6972, lng: 25.2798 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Netherlands",
      businessName: "Atotech B.V.",
      abbreviation: "MERN",
      address: "Strijkviertel 35-2, 3454 PJ De Meern",
      position: { lat: 52.0704, lng: 5.0665 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "Poland",
      businessName: "Atotech Poland Sp.z o.o.",
      abbreviation: "POZN",
      address: "Ul. Marcelińska 92/94, 60-324 Poznań",
      position: { lat: 52.4015, lng: 16.8978 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Portugal",
      businessName: "Atotech España S.A.U.",
      abbreviation: "OIAP",
      address: "Av. Europa, nº 473 C, 3800 – 228 Aveiro",
      position: { lat: 40.6389, lng: -8.6553 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Romania",
      businessName: "Atotech Italia S.r.l.",
      abbreviation: "BUCA",
      address:
        "Calea Dorobantilor Nr. 14-16, 400117 - Cluj City Center, office 003",
      position: { lat: 46.7712, lng: 23.6236 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Slovenia",
      businessName: "Atotech Slovenija d.d.",
      abbreviation: "PODN",
      address: "Podnart 43, 4244 Podnart",
      position: { lat: 46.3028, lng: 14.2298 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "Spain",
      businessName: "Atotech España S.A.U.",
      abbreviation: "ERND",
      address:
        "Apartado 156 - 48950 Erandio, Ribera de Axpe, 39, 48950 Erandio - Bizkaia",
      position: { lat: 43.2937, lng: -2.9514 },
      size: "Small",
    },
    {
      continent: "Europe",
      country: "Spain",
      businessName: "Atotech España S.A.U.",
      abbreviation: "CERA",
      address:
        "Parc Tecnològic del Vallès, Ronda Can Fatjó, 8, 08290 Cerdanyola del Vallès (Barcelona)",
      position: { lat: 41.4902, lng: 2.143 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Sweden",
      businessName: "Atotech Skandinavien AB",
      abbreviation: "NORK",
      address: "Slottsgatan 33, Box 5, SE-60102 Norrköping",
      position: { lat: 58.5877, lng: 16.1924 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "Turkey",
      businessName: "Atotech İstanbul Kimya Sanayi Tic. Ltd. Şti.",
      abbreviation: "ISBU",
      address:
        "Barbaros Mah., Nesime Hanım Sok. No:4, 34746. Ataşehir - İstanbul",
      position: { lat: 40.9927, lng: 29.1207 },
      size: "NA",
    },
    {
      continent: "Europe",
      country: "United Kingdom",
      businessName: "Crewe",
      abbreviation: "CRE",
      address: "Unit 2-4 Cowley Way, Weston Road",
      position: { lat: 53.0897, lng: -2.4497 },
      size: "Medium",
    },
    {
      continent: "Europe",
      country: "United Kingdom",
      businessName: "Atotech UK Ltd.",
      abbreviation: "WBRM",
      address: "William Street, West Bromwich, West Midlands B70 0BG",
      position: { lat: 52.5194, lng: -1.992 },
      size: "Small",
    },
  ],
};
